import { ChevronRight } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useActivePromo } from "@/lib/whatsapp-promo/hooks/use-active-promo";
import { WhatsAppPromoDialog } from "@/lib/whatsapp-promo/whatsapp-promo-dialog";

/**
 * Persistent entry point to re-open the WhatsApp promo dialog after the
 * auto-popup has been dismissed. Renders as the first section on the
 * Customer Service overview. Hides itself when there is no active promo
 * or the promo has no images (mirrors the dialog's own image-first guard).
 */
export function PromoSection() {
  const { t } = useTranslation("reviews");
  const { promo } = useActivePromo();
  const [open, setOpen] = useState(false);

  if (!promo || promo.images.length === 0) {
    return null;
  }

  const thumbnail = promo.images[0]?.url;

  return (
    <div className="space-y-3">
      <div className="pl-1.5 space-y-1">
        <h2 className="text-lg font-semibold">{t("promo.heading")}</h2>
        <p className="text-xs text-muted-foreground mt-0.5">{t("promo.subheading")}</p>
      </div>

      <button
        type="button"
        onClick={() => setOpen(true)}
        className="w-full text-left flex items-center gap-3 rounded-lg border border-border/60 bg-card hover:border-foreground/20 hover:shadow-sm transition-all p-3 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        {thumbnail && (
          <img src={thumbnail} alt="" className="h-14 w-14 shrink-0 rounded-md object-cover" />
        )}
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium truncate">{promo.name}</p>
          <p className="text-xs text-muted-foreground mt-0.5 truncate">{t("promo.helper")}</p>
        </div>
        <span className="hidden sm:inline text-sm font-medium text-primary shrink-0">
          {t("promo.view")}
        </span>
        <ChevronRight className="h-5 w-5 text-muted-foreground shrink-0" />
      </button>

      <WhatsAppPromoDialog open={open} onOpenChange={setOpen} promo={promo} />
    </div>
  );
}
